import "react-datepicker/dist/react-datepicker.css";
import i18n from "../../../constants/i18n";
import {
  COUTRIES_GROUP_PICKER_ENTRIES,
  STATUS_PICKER_ENTRIES
} from "../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getReportsStore from "../../../stores/reports-store";
import OrderPicker from "./OrderPicker";
import DateReportPicker from "./DateReportPicker";
import Et3Button from "../../../core/et3-button";
import { colors } from "../../../core/et3-theme/colors";
import ET3Div from "../../../core/et3-div";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import React from "react";
import ReportsLimitPicker from "./ReportsLimitPicker";
import Et3Picker from "../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../TypesNEW";

const ReportsForm = withLiteObserverAndTheme(() => {
  const status = getReportsStore().status.get().value;
  const isCleanButtonEnabled =
    getReportsStore().isDefinedPendingReportsData.get();
  const notPendingReports = status !== "pending";

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("STATUS")}
          options={STATUS_PICKER_ENTRIES}
          onChoose={(value: TEt3PickerSingleValue) => {
            getReportsStore().setReportStatus(value);
          }}
          value={getReportsStore().status.get()}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <OrderPicker notPendingReport={notPendingReports} />
        <Et3Margin top={0} bottom={0} right={30} left={0} />
        <Et3Picker
          label={i18n.get("COUNTRY_CREATED_FROM")}
          options={COUTRIES_GROUP_PICKER_ENTRIES}
          onChoose={(value: TEt3PickerSingleValue) => {
            getReportsStore().setReportCreatedFromType(value);
          }}
          value={getReportsStore().createdFromType.get()}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} right={30} left={0} />
        <ReportsLimitPicker />
      </ET3Div>
      <DateReportPicker notPendingReport={notPendingReports} />
      <Et3Margin top={30} bottom={0} right={0} left={0} />
      <ET3Div
        isScrollable={false}
        width={1200}
        height={45}
        color={colors.all.transparent}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        style={{}}
        onClick={() => {}}
      >
        <Et3Button
          isEnabled={true}
          onClick={async () => {
            await getReportsStore().getReports(false);
          }}
          size="LARGE"
          text="GET"
          type="GET"
        />
        <Et3Margin top={0} bottom={0} right={30} left={0} />
        <Et3Button
          isEnabled={isCleanButtonEnabled}
          onClick={() => {
            getReportsStore().cleanReportsPool();
          }}
          size="LARGE"
          type="REJECT"
          text="CLEAN_POOL"
        />
      </ET3Div>
    </React.Fragment>
  );
});
export default ReportsForm;
